import { useMemo } from "react"
import { Box, useTheme } from "@mui/material"
import { EmptyData } from "components/EmptyData"
import { Head } from "components/Head"
import { ServiceIcon } from "components/icons"
import { LuxuryCard } from "extensions/iconsiam/components/domains/luxury/Card"
import { Header } from "extensions/iconsiam/components/Header"
import { HeaderSearchButton } from "extensions/iconsiam/components/Header/HeaderSearchButton"
import { PageLayout } from "extensions/iconsiam/layouts/PageLayout"
import { useTranslation } from "providers/i18n"
import { getIcon } from "utils/icon"
import { getPostDetail } from "utils/feature"
import { useLuxury } from "extensions/iconsiam/hooks/luxury"

const transformLuxury = (data) => getPostDetail(data)

export const LuxuryPage = ({ Layout = PageLayout }) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { root, emptyDataContainer, gridContainer, luxuryCard } =
    theme.components?.[`LuxuryPage`]?.styleOverrides || {}
  const { hasData, luxuries } = useLuxury()

  const emptyIcon = useMemo(
    () => getIcon(theme?.assets?.empty?.luxury) || <ServiceIcon />,
    [theme]
  )

  return (
    <>
      <Head title={t("Luxury")} />
      <Layout header={<Header searchButton={<HeaderSearchButton />} />}>
        <Box sx={root}>
          {hasData ? (
            <Box sx={gridContainer}>
              {luxuries.map((luxury, index) => (
                <LuxuryCard
                  data={transformLuxury(luxury)}
                  key={index}
                  sx={luxuryCard}
                />
              ))}
            </Box>
          ) : (
            <Box sx={emptyDataContainer}>
              <EmptyData
                icon={emptyIcon}
                primary={t("No Luxury")}
                secondary={t("Stay tuned for the update")}
              />
            </Box>
          )}
        </Box>
      </Layout>
    </>
  )
}
